Controller.$inject = [];

function Controller() {

}

export function HuiModal() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            sizing: '@',
            shaking: '<',
            cssClass: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div class="hui-modal h-modal modal"
                    modal-animate-shake="{{$huiCtrl.shaking ? 'true' : 'false'}}"
                    tabindex="-1"
                    role="dialog">
                    <div class="modal-dialog animated"
                         role="document"
                         ng-class="['modal-' + ($huiCtrl.sizing || 'md'), $huiCtrl.cssClass]">
                        <div class="modal-content" ng-transclude></div>
                    </div>
                </div>
            `;
        }
    }
}